import React from 'react';
/**
 * Renders the preloader
 */

const Loader = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "preloader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "status"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bouncing-loader"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null))));
};

export default Loader;